<template>
		<div class="content wrap-page">
		<Header></Header>
			<div class="info crfff">
        <div class="back" @click="back" style="">
          <img width="70" src="../../static/images/back.png" />
          <span class="fs50 w-title ac">{{$t('rankList')}}</span>
        </div>
        <div class="rank-list mt30">
          <div class="li" v-for="(item,index) in redeemList">
            <div class="li-t disflex">
              <img style="width: 135px; height: 135px;border-radius: 100%" :src="item.avatar" />
              <div style="width: calc(100% - 135px);">
                <div class="lf" :class="'lf'+index">
                  <div class="disflex">
                    <div class="">
                      <div class="title">{{item.nickname}}</div>
                      <div class="prz">{{item.mobile}}</div>
                    </div>
                  </div>
                </div>
                <div class="rf disflex">
                  <div class="disflex">
                    <div class="pt-font pt-font2"><span> <img width="60" class="img1" src="../../static/images/rank-ic1.png">{{$t('Level')}}{{item.level}}</span></div>
                  </div>
                  <div class="disflex">
                     <div class="pt-font"><span> <img class="img1" src="../../static/images/hd-ic3.png">{{item.points}}</span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
			</div>
		</div>
</template>
<script>
import Header from '../components/Header'
import Dialog from '../components/dialog'
export default {
    components:{
		Header,
    Dialog
    },
    data() {
      return {
       isShow:null,
       info:{},
       redeemInfo:{},
        redeemList:[]
      }
    },
	created(){
    this.getRedeem()
	},
  methods: {
		back(){
			this.$router.go(-1);
      // this.$router.push({path:'/land',query: {msisdn:this.$route.query.mobile}});
		},
    getRedeem(){
      let that = this
      that.$parent.loadModal(true);
      that.$api.post('/api/index/ranking',null,r =>{
        that.redeemList = r.data
        that.$parent.loadModal(false);
      })
    },
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/rankList.vue